import { LOADING_FLAG, LOADING_TIP } from '../actionTypes/loadingTypes'
export const loadingActions = payload => {
  return {
    type: LOADING_FLAG,
    payload
  }
}
export const loadingActionsTip = payload => {
  return {
    type: LOADING_TIP,
    payload
  }
}
